import {Component, Injector, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Log, LogTag} from '../../services/Log';
import {concatMap, filter, fromEvent, interval, Observable, of, switchMap} from "rxjs";
import {delay, take} from "rxjs/operators";
import {RegDialogComponent} from "../reg-dialog/reg.dialog.component";
import {PlayerPwaService} from "../../services/PlayerService/player.pwa.service";
import {PlayerBaseService} from "../../services/PlayerService/player.base.service";

@Component({
    selector: 'app-check-internet-connection',
    templateUrl: './check.internet.connection.component.html',
    styleUrls: ['../reg-dialog/reg.dialog.component.css', './check.internet.connection.component.css']
})
export class CheckInternetConnectionComponent extends RegDialogComponent implements OnInit {
  showMessage = false;

  constructor(protected injector: Injector) {
    super(injector);
  }

  ngOnInit() {
  }

  isConnected(): Observable<any> {
    const logInfo = Log.getLogInfo("CheckInternetConnectionComponent", "constructor", []);

    if (window.navigator.onLine) {
      Log.d(logInfo, LogTag.REGISTRATION, 'onLine');
      return of(true);
    } else {
      Log.d(logInfo, LogTag.REGISTRATION, 'offline');
      this.showMessage = true;
      this.changeDetectorRef.detectChanges();
      return fromEvent(window, 'online').pipe(
        take(1)
      )
    }
  }
}
